export default __webpack_public_path__ + "static/media/Candidate_Report_Emails_Template.663a22f3.xlsx";